import React from "react"

import { Icon } from "@/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"
import { QuorumTheme } from "app/static/frontend/design-constants"

const thumbsDownColor = QuorumTheme.colors.red[5]
const thumbsUpColor = QuorumTheme.colors.green[5]

function getTip(children, sheetDataType) {
    switch (sheetDataType) {
        case DjangIO.app.models.QuorumDataType.bill.value:
            return DjangIO.app.userdata.types.SheetStanceVoteResultType.by_value(parseInt(children)).bill_sheet_tip

        default:
            return DjangIO.app.userdata.types.SheetStanceVoteResultType.by_value(parseInt(children)).cell_tip
    }
}

export const StanceCell = ({ children, ...props }) => {
    const stance = DjangIO.app.userdata.types.SheetStanceVoteResultType.by_value(parseInt(children))

    const buildIcon = () => {
        if (stance === DjangIO.app.userdata.types.SheetStanceVoteResultType.support) {
            return <Icon icon="thumbs-up" color={thumbsUpColor} />
        } else if (stance === DjangIO.app.userdata.types.SheetStanceVoteResultType.oppose) {
            return <Icon icon="thumbs-down" color={thumbsDownColor} />
        }

        return <Icon icon="neutral" iconFamily="q" />
    }

    return (
        <CellWrapper className="stance-cell" {...props}>
            {children ? <Tooltip label={getTip(children, props.sheetDataType)}>{buildIcon()}</Tooltip> : children}
        </CellWrapper>
    )
}

export default StanceCell
